import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'react-tabs/style/react-tabs.css';
import './styles/components/FullScreenLoader.scss';
import './styles/base/table/table.scss';

document.querySelectorAll('[data-app="react_block"]').forEach((block) => {
  let module = block.getAttribute('data-module');
  const root = createRoot(block);
  root.render(<App module={module} />);
});

Drupal.lspReact = Drupal.lspReact || {};
Drupal.lspReact.initiateReactApp = (module, id) => {
  const root = createRoot(document.getElementById(id));
  root.render(<App module={module} />);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
